import { createFileRoute } from "@tanstack/react-router";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { LegalLayout } from "@/components/legal/LegalLayout";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";

export const Route = createFileRoute("/_main/politica-de-privacidade")({
  component: PoliticaPrivacidade,
});

function PoliticaPrivacidade() {
  const [pagina, setPagina] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPagina() {
      const { data } = await (supabase as any)
        .from("paginas_legais")
        .select("*")
        .eq("slug", "politica-de-privacidade")
        .eq("publicada", true)
        .single();
      
      if (data) setPagina(data);
      setLoading(false);
    }
    fetchPagina();
  }, []);

  if (loading) return null;

  const sections = [
    { id: "1", title: "1. Coleta de Dados" },
    { id: "2", title: "2. Finalidades e Bases Legais" },
    { id: "3", title: "3. Segurança dos Dados" },
    { id: "4", title: "4. Compartilhamento" },
    { id: "5", title: "5. Seus Direitos" },
    { id: "6", title: "6. Contato" },
  ];

  return (
    <LegalLayout
      title={pagina?.titulo || "Política de Privacidade"}
      lastUpdate={pagina?.versao || "8 de agosto de 2026"}
      sections={sections}
      canonical="https://spark-smile-hub.lovable.app/politica-de-privacidade"
      description="Saiba como a Gopage protege seus dados pessoais."
    >
      <div className="prose prose-slate max-w-none">
        <ReactMarkdown 
          remarkPlugins={[remarkGfm]} 
          rehypePlugins={[rehypeSanitize]}
        >
          {pagina?.conteudo || ""}
        </ReactMarkdown>
      </div>
    </LegalLayout>
  );
}
